import { NavLink } from "react-router-dom";
import { constants } from "../../Utils/constants";

const { PRIVACY_URL, TERMS_URL, ID } = constants.OPERATING_ENTITIES.NAYAX;

export const CheckoutAgreement = ({ operatingEntityId }) => {
  const isNayax = operatingEntityId === ID;

  return (
    <div className='tc-container'>
      <p>
        {`${isNayax ? 'By clicking the checkout, I agree to Nayax\'s ' : `By clicking the checkout, I agree that NAYAX will share my
                      data with NAYAX Capital, a NAYAX affiliate, subject to NAYAX
                      Capital's `}`}
        {isNayax ? (
          <a className='nav-link' href={PRIVACY_URL} target='_blank' rel='noreferrer'>
            Privacy Policy
          </a>
        ) : (
          <NavLink className='nav-link' to='/privacy-policy' target='_blank'>
            Privacy Policy
          </NavLink>
        )}
        {" "}and{" "}
        {isNayax ? (
          <a className='nav-link' href={TERMS_URL} target='_blank' rel='noreferrer'>
            T&#x26;Cs
          </a>
        ) : (
          <NavLink className='nav-link' to='/terms-conditions' target='_blank'>
            T&#x26;Cs
          </NavLink>
        )}
      </p>
    </div>
  );
};
